import { Mesh, MeshBasicMaterial, Shape, ShapeGeometry } from 'three';
import { globalStores } from '@/editor/stores';
import BaseModel2d from './BaseModel2d';
import { IPoint2d } from '@/editor/math/IPoint2d';
import HighlightedLine from './highlightedLine';
import { selectedOutlineColor, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { pixelRatio2d } from '@/editor/math/const';

export class AlignHighlightModel extends BaseModel2d {
  private _boundBox: IPoint2d[] = [];
  constructor() {
    super();
    this.setDisplayOrder(ENTITY_RENDER_ORDER.renderOrderTemp);
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  private _createMaskMesh() {
    const geometry = this._createMaskEntGeometry();
    const maskMaterial = new MeshBasicMaterial({
      color: selectedOutlineColor,
      transparent: true,
      opacity: 0.3
    });
    maskMaterial.depthTest = false;
    const maskMesh = new Mesh(geometry, maskMaterial);
    maskMesh.renderOrder = ENTITY_RENDER_ORDER.renderOrderTemp;

    return maskMesh;
  }

  private _createOutline() {
    for (let i = 0; i < this._boundBox.length; i++) {
      const start = this._boundBox[i];
      const end = this._boundBox[(i + 1) % this._boundBox.length];
      const highlightedLine = new HighlightedLine([start, end], ENTITY_RENDER_ORDER.wallOutline);
      highlightedLine.setHighlightedColor(selectedOutlineColor, 1);
      // highlightedLine.highlightedLine.renderOrder = ENTITY_RENDER_ORDER.renderOrderTemp;
      this._modelGroup.add(highlightedLine.highlightedLine);
    }
  }

  private _createMaskEntGeometry() {
    const heartShape = new Shape();
    for (let i = 0; i < this._boundBox.length; i++) {
      if (i === 0) {
        heartShape.moveTo(this._boundBox[i].x / pixelRatio2d, this._boundBox[i].y / pixelRatio2d);
      } else {
        heartShape.lineTo(this._boundBox[i].x / pixelRatio2d, this._boundBox[i].y / pixelRatio2d);
      }
    }

    return new ShapeGeometry(heartShape);
  }

  update(bounds: IPoint2d[]) {
    if (!bounds.length) {
      this.clear();
    } else {
      this._boundBox = bounds;
      this._createOutline();
      const maskMesh = this._createMaskMesh();
      this._modelGroup.add(maskMesh);
    }
  }

  override clear() {
    super.clear();
  }
}
